module.exports = __webpack_public_path__ + "img/yi-yao.4d15b0ea.png";